/** Dev-only gallery. Not a product route and not in the nav. */
export const DESIGN_GALLERY_PATH = "/design-system";

export function isDesignGalleryPath(pathname: string): boolean {
  const bare = pathname.split("?")[0].replace(/\/+$/, "") || "/";
  return bare === DESIGN_GALLERY_PATH;
}

/**
 * Compile-time gate so a production bundle can drop the page.
 *
 * Vite dev is on. dev.app.semanticad.ai is a production Vite build; the flag
 * that build sets, and production does not, is an empty
 * `VITE_SEMANTICAD_ENGINE_URL` (same-origin engine — deploy-dev.yml).
 * Production bakes `https://api.semanticad.ai`. An unset URL is not that flag.
 *
 * `?e2e=1` does not open this route.
 */
export const DESIGN_GALLERY_ENABLED =
  import.meta.env.DEV || import.meta.env.VITE_SEMANTICAD_ENGINE_URL === "";

export function isDesignGalleryEnabled(env?: { dev?: boolean; engineUrl?: string }): boolean {
  if (!env) return DESIGN_GALLERY_ENABLED;
  if (env.dev) return true;
  return env.engineUrl === "";
}
